import { SupportedLocaleCode } from '@/services/locales/locales.models';
import { getLocaleOptions } from '@/utils/locales';
import { Button, FieldError, SelectInput } from '@payloadcms/ui';
import { useState } from 'react';

import { WizardStepHeader } from './WizardStepHeader';

interface SupportedLocalesFormProps {
  supportedLocales: SupportedLocaleCode[];
  onSupportedLocalesChange: (locales: SupportedLocaleCode[]) => void;
  onContinue: (locales: SupportedLocaleCode[]) => void;
  onBack: () => void;
}

export const SupportedLocalesForm = ({ supportedLocales, onSupportedLocalesChange, onContinue, onBack }: SupportedLocalesFormProps) => {
  const [supportedLocalesError, setSupportedLocalesError] = useState('');

  const handleLocalesSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (!supportedLocales?.length) {
      setSupportedLocalesError('Supported locales are required');
      return;
    }

    setSupportedLocalesError('');
    onContinue(supportedLocales);
  };

  return (
    <div data-testid="create-new-landing-step-locales">
      <WizardStepHeader title="Select the supported locales" onBack={onBack} />
      <p>Select the locales that you want to support for this landing. You can add more locales later.</p>
      <form onSubmit={handleLocalesSubmit}>
        <div data-testid="create-new-landing-locales-field">
          <SelectInput
            onChange={(options) => {
              if (Array.isArray(options)) {
                const values = options.map((option) => option.value) as string[];
                onSupportedLocalesChange(values as SupportedLocaleCode[]);
              }
            }}
            value={supportedLocales}
            name="supportedLocales"
            path="supportedLocales"
            label="Supported Locales"
            options={getLocaleOptions()}
            hasMany={true}
            required={true}
            Error={
              <FieldError
                path="supportedLocales"
                message={supportedLocalesError || 'Supported locales are required'}
                showError={!!supportedLocalesError}
              />
            }
          />
        </div>
        {supportedLocalesError && (
          <span data-testid="create-new-landing-locales-error" hidden>
            {supportedLocalesError}
          </span>
        )}
        <div className="fv-create-new-landing-modal__step-actions">
          <Button type="submit" buttonStyle="primary" extraButtonProps={{ 'data-testid': 'create-new-landing-locales-continue' }}>
            Continue
          </Button>
        </div>
      </form>
    </div>
  );
};
